import { createQueryKeys } from "@lukemorales/query-key-factory";
import type { QueryKey } from "@tanstack/react-query";

import type { Service } from "../service";

const REVIEW = "review";
const CREATE = "create";
const UPDATE = "update";
const DELETE = "delete";
const APPROVE = "approve";
const GET = "get";
const GET_FOR_ADMIN = "getForAdmin";
const GET_MANY = "getMany";
const GET_PAGINATED = "getPaginated";
const GET_PAGINATED_FOR_ADMIN = "getPaginatedForAdmin";
const GET_BY_ORDER = "getByOrder";

const MUTATION_KEYS = {
  [CREATE]: [REVIEW, CREATE],
  [UPDATE]: [REVIEW, UPDATE],
  [DELETE]: [REVIEW, DELETE],
  [APPROVE]: [REVIEW, APPROVE],
} as const satisfies Record<string, QueryKey>;

const QUERY_KEYS = createQueryKeys(REVIEW, {
  [GET]: (params: Parameters<Service[typeof GET]>[0]) => [params],
  [GET_FOR_ADMIN]: (params: Parameters<Service[typeof GET_FOR_ADMIN]>[0]) => [params],
  [GET_MANY]: null,
  [GET_PAGINATED]: (params: Parameters<Service[typeof GET_PAGINATED]>[0]) => [params],
  [GET_PAGINATED_FOR_ADMIN]: (params: Parameters<Service[typeof GET_PAGINATED_FOR_ADMIN]>[0]) => [
    params,
  ],
  [GET_BY_ORDER]: (params: Parameters<Service[typeof GET_BY_ORDER]>[0]) => [params],
});

export {
  APPROVE,
  CREATE,
  DELETE,
  GET,
  GET_BY_ORDER,
  GET_FOR_ADMIN,
  GET_MANY,
  GET_PAGINATED,
  GET_PAGINATED_FOR_ADMIN,
  MUTATION_KEYS,
  QUERY_KEYS,
  REVIEW,
  UPDATE,
};
